<!-- 
GroupInsuranceKeyMan.vue
功能：團險 Key man
作者：i9400538 陳博承
完成：2021-08-30
-->
<template>
  <div>
    <div class="container-fluid div-1">
      <div class="mb-3 mb3-block" :class="{'section-loading': infoLoading}">
        <div class="float-left w-75">
          <h4 class="mb-line text-green mt-0 mb-0">
            {{ categoryInfo.subcategory }}-{{ categoryInfo.category_name }}
            <a
              v-if="categoryInfo.upload_file"
              class="text-orange text-1"
            >
              <i class="icon-attach ml-2 cursor-1" @click="download(categoryInfo.upload_file)"></i>教案
            </a>
          </h4>
          <div class="mb-line">
            <span
              class="font-weight-bold mr-2"
            >{{ categoryInfo.upload_date | dateFormat }} ~ {{ categoryInfo.end_date | dateFormat }}</span>
          </div>
          <div class="mb-line w-75">
            <span class="font-weight-bold mr-2">{{ categoryInfo.description }}</span>
          </div>
        </div>
        <div class="float-left w-25">
          <div class="mb-line">
            <span class="font-weight-bold mr-2">維護單位</span>
            <span>{{ categoryInfo.dev_name }}</span>
          </div>
          <div class>
            <span class="font-weight-bold mr-2">聯絡電話</span>
            <span>{{ categoryInfo.contact }}</span>
          </div>
          <div class="mb-line">
            <span class="font-weight-bold mr-2">聯絡分機</span>
            <span>{{ categoryInfo.contact_tel }}</span>
          </div>
          <div :class="{'section-loading': isLoading_btn}">
            <a class="btn btn-default m-0" @click="satisfactionModal" v-if="isBtnEnble">滿意度調查</a>
            <a class="btn btn-default m-0" @click="alreadyDone" disabled="disabled" v-else>滿意度調查</a>
            &nbsp;&nbsp;
            <button
              type="button"
              @click="backToIndex"
              class="position-absolute btn btn-default m-0 h-43"
              v-html="'<span class=\'font-1\'>回上一頁<span>'"
            ></button>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
    <div class="container-fluid" :class="{'section-loading': isLoading}">
      <div class="row">
        <group-insurance-key-man-data-table
          :height="data_table_height"
          @update="updateSelection"
          @scheduled-access="ScheduledAccess"
          @init="init"
          :table-data="tableData"
        />
      </div>
    </div>

    <section class="container-fluid fixed-bottom">
      <div class="row">
        <div class="col-12"></div>
        <div class="col-9 col-sm-8 col-md-8"></div>
        <div class="col-3 col-sm-4 col-md-4 text-right">
          <button
            type="button"
            class="btn btn-primary"
            @click="panelOpen('groupModalOpen')"
            :disabled="!selection.length"
          >加入群組</button>
          <button
            type="button"
            class="btn btn-primary mr-0"
            @click="panelOpen('printModalOpen')"
            :disabled="!selection.length"
          >列印名條</button>
        </div>
      </div>
    </section>

    <!-- 列印名條 -->
    <print-modal :open="printModalOpen" :custs="selection" @close="panelClose('printModalOpen')" />

    <!-- 加入群組 -->
    <group-modal
      :open="groupModalOpen"
      :custs="selection"
      @submit="submitGroup"
      @close="panelClose('groupModalOpen')"
    />

    <!-- 滿意度調查 -->
    <satisfaction-modal
      :open="satisfactionModalOpen"
      @report="report"
      @close="panelClose('satisfactionModalOpen')"
    />

    <!-- 排訪 -->
    <scheduled-access
      :open="ScheduledAccessModalOpen"
      :record="currentRecord"
      :cat-info="categoryInfo"
      @close="panelClose('ScheduledAccessModalOpen')"
      @submit="submitScheduledAccess"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { commonMixin } from "@/mixins/common";
import { saveAs } from "file-saver";
//component
import PrintModal from "@/desktop/components/PrintModal";
import GroupModal from "@/desktop/components/GroupModal";
import GroupInsuranceKeyManDataTable from "@/desktop/components/ListsArea/DataTable/GroupInsuranceKeyManDataTable";
import SatisfactionModal from "@/desktop/components/ListsArea/SatisfactionModal";
import ScheduledAccess from "@/desktop/components/ListsArea/ScheduledAccess";
//service
import {
  getGroupInsuranceKeyMan,
  getCategoryDetail,
  isSatisfactionSurveyFinish,
  queryBookedVisitEvent,
  downloadFile_m0
} from "@/service";

export default {
  name: "GroupInsuranceKeyMan",
  mixins: [commonMixin],
  components: {
    GroupInsuranceKeyManDataTable,
    SatisfactionModal,
    PrintModal,
    GroupModal,
    ScheduledAccess
  },
  data() {
    return {
      isLoading_btn: true,
      isLoading: false,
      infoLoading: false,
      isBtnEnble: true,
      categoryInfo: {},
      printModalOpen: false,
      groupModalOpen: false,
      tableData: [],
      selection: [],
      satisfactionModalOpen: false,
      data_table_height: 0,
      ScheduledAccessModalOpen: false,
      currentRecord: {}
    };
  },
  methods: {
    ...mapActions(["setPageLock", "updateCustID"]),
    updateSelection(val) {
      this.selection = val;
    },
    PrintModal() {
      this.panelOpen("printModalOpen");
    },
    satisfactionModal() {
      this.panelOpen("satisfactionModalOpen");
    },
    report() {
      this.$toast.info({ title: "滿意度調查 已回報" });
      this.isBtnEnble = false;
      this.panelClose("satisfactionModalOpen");
    },
    //回上一頁
    backToIndex() {
      this.$emit("change-status", "STATUS_GROUP_RELATED_LIST");
    },
    submitGroup(group) {
      // 加入群組導頁至 群組列表
      this.panelClose("groupModalOpen");
      this.$router.push({
        path: `/group/1`,
        query: { grp_id: group.grp_id, grp_name: group.grp_name }
      });
    },
    init(order) {
      // 資料初始化
      this.isLoading = true;
      getGroupInsuranceKeyMan(this.$store.state.userInfo.id, order).then(
        result => {
          this.isLoading = false;
          if (
            result.header &&
            result.header.status === "200" &&
            result.body.result
          ) {
            let connect = "";
            let CsidData = "";
            result.body.result.map(item => {
              connect = connect + "," + item.id;
            });
            if (connect.length > 0) {
              CsidData = connect.substr(1);
            }
            queryBookedVisitEvent(this.$store.state.userInfo.id, CsidData).then(
              visitData => {
                this.isLoading = false;
                if (visitData.header && visitData.header.status === "200") {
                  let visitList = visitData.body.detail;
                  this.tableData = result.body.result.map(item => {
                    let visit = { visit: {} };
                    visitList.forEach(vItem => {
                      if (vItem.csidno == item.id) {
                        visit.visit = vItem;
                      }
                    });
                    return {
                      id: item.id || "", //客戶ID
                      name: item.name || "", //客戶姓名
                      sex: Number(item.id[1]) || "", //性別
                      vip_level: item.vip_lvl, // 顯示VIP
                      mobile: item.mobile || "", //手機
                      department: item.department || "", //公司名稱
                      job_title: item.job_title || "", //職稱
                      is_exist: item.is_exist || false, //判斷是否有客戶資料
                      ...visit // 寫入排訪資料
                    };
                  });
                }
              }
            );
            this.registerHanlink(); // for hard word
          }
        }
      );
    },
    //取得專區資訊
    getTitleInfo() {
      this.infoLoading = true;
      getCategoryDetail(
        this.$store.state.userInfo.id,
        this.$store.state.listAreaSerNo
      ).then(result => {
        this.infoLoading = false;
        if (result.header && result.header.status == "200") {
          this.categoryInfo = result.body[0];
        }
      });
    },
    //檢查是否已回報過滿意度調查
    checkIsSatisfactionSurveyFinish() {
      this.isLoading_btn = true;
      isSatisfactionSurveyFinish(
        this.$store.state.userInfo.id,
        this.$store.state.listAreaSerNo
      ).then(result => {
        if (result.header && result.header.status == "200") {
          this.isBtnEnble = result.body.isfinish == "0";
        } else {
          if (result.header && result.header.message) {
            this.$toast.info({ title: result.header.message });
          } else {
            this.$toast.info({ title: "查詢滿意度調查失敗,請重新操作" });
          }
        }
        this.isLoading_btn = false;
      });
    },
    alreadyDone() {
      this.$toast.info({ title: "您已回報過滿意度調查,無法重複操作" });
    },
    //開啟排訪視窗
    ScheduledAccess(record) {
      this.currentRecord = record;
      this.panelOpen("ScheduledAccessModalOpen");
    },
    //完成排訪，觸發重查
    submitScheduledAccess() {
      this.panelClose("ScheduledAccessModalOpen");
      this.init("1"); //資料初始化
    },
    //檔案下載
    download(file) {
      if (this.$store.state.userInfo.userType === "box") {
        //若内嵌於Box, 將檔案資訊回傳給Box
        this.boxDownload(file, this.categoryInfo.ser_no);
      } else {
        let vm = this;
        downloadFile_m0(
          this.$store.state.userInfo.id,
          this.categoryInfo.ser_no,
          file
        ).then(result => {
          if (result.type == "application/json") {
            //  json 為檔案下載失敗
            //  把回傳的 blob 轉為 文字檔後再用 json parse
            let reader = new FileReader();
            reader.onload = function() {
              let unicodeJsonA = JSON.parse(reader.result);
              if (unicodeJsonA.header.message) {
                vm.setToastMsg(unicodeJsonA.header.message);
              } else {
                vm.setToastMsg("伺服器連線異常");
              }
            };
            reader.readAsText(result);
          } else {
            //  成功取得檔案  進行下載
            saveAs(result, file);
          }
        });
      }
    }
  },
  mounted() {
    // 資料初始化
    this.checkIsSatisfactionSurveyFinish();
    this.getTitleInfo();
    this.init("1");

    this.data_table_height =
      parseInt($(window).height()) - $("tbody").offset().top - 80;
    let self = this;
    $(window).bind("resize", function(event) {
      self.data_table_height =
        parseInt($(window).height()) - $("tbody").offset().top - 80;
    });
    $(".tab-content").css("padding-bottom", "74px");
  }
};
</script>
<style lang="scss" scoped>
.div-1 {
  overflow: hidden;
}
.mb3-block {
  overflow: hidden;
  max-height: 140px;
}
.text-1 {
  text-decoration: none;
}
.cursor-1 {
  cursor: pointer;
}
.h-43 {
  height: 43px;
}
.font-1 {
  font-size: 1rem;
}
</style>